import React from 'react';

/**
 * Inline "Read aloud" / "Stop" button paired with the speech-synthesis hook.
 * Renders nothing on browsers without TTS support — DIR-000 Truth Gate, we
 * don't show a button that wouldn't do anything.
 */
export default function SpeakButton({
  text,
  supported,
  speaking,
  onSpeak,
  onStop,
  size = 'sm',
  testId = 'speak-button',
}) {
  if (!supported || !text) return null;

  const dims = size === 'md' ? 'w-8 h-8' : 'w-6 h-6';
  const icon = size === 'md' ? 16 : 14;

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => (speaking ? onStop() : onSpeak(text))}
      title={speaking ? 'Stop reading' : 'Read aloud'}
      aria-label={speaking ? 'Stop reading' : 'Read aloud'}
      className={`${dims} inline-flex items-center justify-center rounded-full transition-colors ${
        speaking
          ? 'bg-amber-400 text-black animate-pulse'
          : 'bg-white/10 hover:bg-white/20 text-gray-300 hover:text-white'
      }`}
    >
      {speaking ? (
        <svg width={icon} height={icon} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <rect x="6" y="5" width="4" height="14" rx="1" />
          <rect x="14" y="5" width="4" height="14" rx="1" />
        </svg>
      ) : (
        <svg width={icon} height={icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
        </svg>
      )}
    </button>
  );
}
